import { format } from 'date-fns';
import ruLocale from 'date-fns/locale/ru';
import React from 'react';
import PropTypes from 'prop-types';
import { capitalize } from '@culture/common-helpers/string';

import Icon from 'components/Icon';

import styles from './styles.module.scss';

const TopBar = ({
	onPreviousClick,
	onNextClick,
	showPreviousButton,
	showNextButton,
	month
}) => (
	<div className={styles.topBar}>
		<div>{capitalize(format(month, 'LLLL yyyy', { locale: ruLocale }))}</div>
		<div className={styles.navBar}>
			{showPreviousButton && (
				<button
					type="button"
					className={styles.button}
					onClick={() => onPreviousClick()}
					aria-label="Предыдущий месяц"
				>
					<Icon icon="chevronSmallLeft" inheritSize={false} />
				</button>
			)}
			{showNextButton && (
				<button
					type="button"
					className={styles.button}
					onClick={() => onNextClick()}
					aria-label="Следующий месяц"
				>
					<Icon icon="chevronSmallRight" inheritSize={false} />
				</button>
			)}
		</div>
	</div>
);

TopBar.propTypes = {
	onPreviousClick: PropTypes.func.isRequired,
	onNextClick: PropTypes.func.isRequired,
	showPreviousButton: PropTypes.bool.isRequired,
	showNextButton: PropTypes.bool.isRequired,
	month: PropTypes.object.isRequired
};

export default TopBar;
